<template>
  <list-slider
    :data="companies"
    :show-arrows="false"
    :config="{
      cardTemplate: 'company-slider-card',
      attrTemplate: 'company',
      allowedGhost: true
    }"
    :slider-config="{
      slidesPerView: 12,
      slidesPerGroup: 1,
      freeMode: false,
      loop: true,
      speed: 2500,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      breakpoints: {
        1: {
          slidesPerView: 4
        },
        700: {
          slidesPerView: 6
        },
        1000: {
          slidesPerView: 8
        },
        1200: {
          slidesPerView: 12
        }
      }
    }"
  />
</template>

<script>
export default {
  computed: {
    companies() {
      return [
        {
          url: 'https://www.bokovka.com/',
          image: '/assets/companies-slider/27/01-Bokovka.svg'
        },
        {
          url: 'https://www.restauracebrasileiro.cz/',
          image: '/assets/companies-slider/30/02-Brasileiro.svg'
        },
        {
          url: 'https://bufetkarlin.cz/',
          image: '/assets/companies-slider/22/03-Bufet.svg'
        },
        {
          url: 'http://cafesavoy.ambi.cz/',
          image: '/assets/companies-slider/24/04-CafeSavoy.svg'
        },
        {
          url: 'https://cestr.ambi.cz/',
          image: '/assets/companies-slider/48/05-Cestr.svg'
        },
        {
          url: 'https://www.dvakohouti.cz/',
          image: '/assets/companies-slider/23/06-DvaKohouti.svg'
        },
        {
          url: 'https://eska.ambi.cz/',
          image: '/assets/companies-slider/26/07-Eska.svg'
        },
        {
          url: 'https://www.kantyna.ambi.cz/',
          image: '/assets/companies-slider/28/10-Kantyna.svg'
        },
        {
          url: 'https://kuchyn.ambi.cz/',
          image: '/assets/companies-slider/33/12-Kuchyn.svg'
        },
        {
          url: 'https://www.ladegustation.cz/',
          image: '/assets/companies-slider/53/13-LaDegustation.svg'
        },
        {
          url: 'https://lokal.ambi.cz/',
          image: '/assets/companies-slider/40/14-Lokal.svg'
        },
        {
          url: 'https://www.mysak.ambi.cz/',
          image: '/assets/companies-slider/34/15-Mysak.svg'
        },
        {
          url: 'https://www.nasemaso.cz',
          image: '/assets/companies-slider/35/17-NaseMaso.svg'
        },
        {
          url: 'https://pastacaffe-vezenska.ambi.cz/',
          image: '/assets/companies-slider/37/19-PastaCaffe.svg'
        },
        {
          url: 'https://pastafresca.ambi.cz/',
          image: '/assets/companies-slider/36/20-PastaFresca.svg'
        },
        {
          url: 'https://www.pizzanuova.cz/',
          image: '/assets/companies-slider/38/21-PizzaNuova.svg'
        },
        {
          url: 'https://www.pult.ambi.cz/',
          image: '/assets/companies-slider/54/215-Pult.svg'
        },
        {
          url: 'https://www.ukalendu.ambi.cz/',
          image: '/assets/companies-slider/52/22-UKalendu.svg'
        }
      ]
    }
  }
}
</script>

<style lang="scss"></style>
